export class DisplayConnectActivityAction {
    constructor() {
        this.name = 'DisplayConnectActivity';
        this.isDeviceAction = false;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGlzcGxheUNvbm5lY3RBY3Rpdml0eUFjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWxzL2FjdGlvbnMvRGlzcGxheUNvbm5lY3RBY3Rpdml0eUFjdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLQSxNQUFNLE9BQU8sNEJBQTRCO0lBQXpDO1FBQ2tCLFNBQUksR0FBRyx3QkFBd0IsQ0FBQztRQUNoQyxtQkFBYyxHQUFHLEtBQUssQ0FBQztJQUN6QyxDQUFDO0NBQUEifQ==